import LtiToolDeployment from '@/models/LtiToolDeployment.js';
import Model from '@/models/Model.js';
import axios from '@/plugins/axios.js';

export const COMMIT_COURSE_ACTIVITY = 'course_activity';
export const COMMIT_COURSE_TEMPLATE_ACTIVITY = 'course_template_activity';

export default class LtiResourceContent extends Model {
    static entity = 'lti_resource_contents';

    static fields() {
        return {
            id: this.attr(null),
            type: this.attr(null),
            raw: this.attr(null),
            lti_tool_deployment_id: this.attr(null),

            ...super.fields(),

            deployment: this.belongsTo(LtiToolDeployment, 'lti_tool_deployment_id'),
        };
    }

    async commit(type, payload = {}) {
        const { data } = await axios.post(`/api/lti/resource-contents/${this.id}/commit`, { type, payload });

        return data;
    }
}
